import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import configVars from "../config";
import { setWithExpiry, getWithExpiry } from '../common';
import { getUserData } from "../redux/actions/userdata";
import { useDispatch, useSelector } from "react-redux";
import { getExpiry } from '../common';
import { useCookies } from "react-cookie";

const BoardInstructions = () => {

	const [instructions, setInstructions] = useState({});
	const { lesson, topic, board_id } = useParams();

	const [cookies] = useCookies(["sustainyou_user_jwt"]);

	const dispatch = useDispatch();
	const userCapabilities = useSelector((state) => state.userdata.allUserData?.all_capabilities);

	useEffect(() => {

		if ( ! board_id ) return;

		let expired = getExpiry("user_data_expire");

		const getAllUserData = async (token) => {
			await dispatch(getUserData(token));
		}

		if (cookies.sustainyou_user_jwt) {
			//const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);
			
			if (expired) {
				getAllUserData(cookies.sustainyou_user_jwt);
			}
		}

		const boardGuides = getWithExpiry( `sy_board_${board_id}_guides` );

		if ( boardGuides ) {
			setInstructions( boardGuides );
		} else {
			(async () => {

				const response = await fetch(
					`${configVars.apiUrl}sustainchange/v1/getboardguides/?boardid=${board_id}`,
					{
					  method: "GET",
					  headers: {
						Authorization: `Basic ${configVars.auth}`,
					  },
					}
				);
				
				const courseResponse = await response.json();
	
				if ( courseResponse && courseResponse.data ) {
	
					const responseData = courseResponse.data.data;
	
					setWithExpiry( `sy_board_${board_id}_guides`, responseData );
					setInstructions( responseData );
					return;
				}
	
			})()
		}

	}, [board_id, cookies.sustainyou_user_jwt, dispatch]);
  
	return (
		<div className="intructions-wrap bg-white rounded-3 pb-lg-3 shadow-sm">
			{ instructions && board_id &&
				<>
					{instructions.course_title &&
						<>
							<span className="text-uppercase placeholder-text px-3 py-2 bg-halite-blue text-white d-inline-block w-100">Guide: {instructions.course_title}</span>
						</>
					}
					<nav className="nav flex-column mb-3">
						{Object.keys(instructions).map((lessonID, i) => (
							<>
								{userCapabilities && ! userCapabilities.includes('full_guides') && i <= 1 &&
									<div className="lesson-wrap" key={i} >

										{instructions[lessonID].name &&
											<Link
												to={`/board/${board_id}/guide/${instructions[lessonID].name}`} 
												className={`nav-link placeholder-text d-flex align-items-center border-top  w-100 ${((lesson === instructions[lessonID].name && !topic) || (!lesson && i === 0)) ? 'bg-halite-blue text-white' : null}`}
												onClick={ () => setWithExpiry( 'recent_visited_lesson', instructions[lessonID].name)} >
												<span className="ms-2 text-uppercase">{instructions[lessonID].title}</span>
											</Link>
										}

										{ instructions[lessonID].topics && Object.keys(instructions[lessonID].topics).length > 0 &&
											<div className={`topics-wrap mb-3 ${(lesson === instructions[lessonID].name) ? '' : 'd-none'}`}>
												{Object.keys(instructions[lessonID].topics).map((topicKey, j) => (
													<Link 
														to={`/board/${board_id}/guide/${instructions[lessonID].name}/${instructions[lessonID].topics[topicKey].post_name}`} 
														className={`nav-link placeholder-text py-0 ps-4 mt-1  ${(window.location.pathname === `/board/${board_id}/guide/${instructions[lessonID].name}/${instructions[lessonID].topics[topicKey].post_name}`) ? 'bg-primary text-white' : null}`} 
														key={`${lessonID + j}`}
														onClick={ () => setWithExpiry( 'recent_visited_topic', instructions[lessonID].topics[topicKey].post_name )}
													>
														<span className="ps-2 d-flex align-items-center">
															<i className="fa fa-circle" aria-hidden="true"></i>
															<span className="ms-2">{instructions[lessonID].topics[topicKey].post_title}</span>
														</span>
													</Link>
												))}
											</div>
										}

									</div>
								}

								{userCapabilities && userCapabilities.includes('full_guides') &&
									<div className="lesson-wrap" key={i} >

										{instructions[lessonID].name &&
											<Link
												to={`/board/${board_id}/guide/${instructions[lessonID].name}`} 
												className={`nav-link placeholder-text d-flex align-items-center border-top  w-100 ${((lesson === instructions[lessonID].name && !topic) || (!lesson && i === 0)) ? 'bg-halite-blue text-white' : 'text-halite-blue'}`}
												onClick={ () => setWithExpiry( 'recent_visited_lesson', instructions[lessonID].name)} >
												<span className="ms-2 text-uppercase">{instructions[lessonID].title}</span>
											</Link>
										}

										{ instructions[lessonID].topics && Object.keys(instructions[lessonID].topics).length > 0 &&
											<div className={`topics-wrap mb-3 ${(lesson === instructions[lessonID].name) ? '' : 'd-none'}`}>
												{Object.keys(instructions[lessonID].topics).map((topicKey, j) => (
													<Link 
														to={`/board/${board_id}/guide/${instructions[lessonID].name}/${instructions[lessonID].topics[topicKey].post_name}`} 
														className={`nav-link placeholder-text py-0 ps-4 mt-1  ${(window.location.pathname === `/board/${board_id}/guide/${instructions[lessonID].name}/${instructions[lessonID].topics[topicKey].post_name}`) ? 'bg-halite-blue text-white' : 'text-halite-blue'}`} 
														key={`${lessonID + j}`}
														onClick={ () => setWithExpiry( 'recent_visited_topic', instructions[lessonID].topics[topicKey].post_name )}
													>
														<span className="ps-2 d-flex align-items-center">
															<i className="fa fa-circle" aria-hidden="true"></i>
															<span className="ms-2">{instructions[lessonID].topics[topicKey].post_title}</span>
														</span>
													</Link>
												))}
											</div>
										}

									</div>
								}
								
							</>
						))}
					</nav>
				</>
				
			}

		</div>
	);
};

export default BoardInstructions;